import { Avatar, Tag } from "antd";
import RoundedButton from "../UI/RoundedButton";
import { GearIcon, UserIcon } from "../icon";
import { useNavigate } from "react-router";
import { usePermissions } from "@/common/contexts/Permissions.context";
import Typography from "../Typography/Typography";

export default function UserInfo() {
  const navigate = useNavigate();
  const { user } = usePermissions();
  const toUserPage = () => {
    navigate(`/user/me`);
  };
  return (
    <div
      onClick={toUserPage}
      className="cursor-pointer py-2 px-5 w-full max-w-[267px] bg-white rounded-full flex justify-between items-center"
    >
      {!!user && (
        <>
          <div className="flex gap-3 items-center">
            <Avatar
              className="w-12 h-12"
              icon={
                user?.profileImageURL ? (
                  <>
                    <img width={48} src={user?.profileImageURL} />
                  </>
                ) : (
                  <UserIcon />
                )
              }
            />
            <div className="flex flex-col">
              <Tag className="capitalize text-base font-kanit font-light rounded-full bg-primaryDim text-primary border-none">
                {user?.roleID % 2 !== 1 ? "Admin" : "Standard"}
              </Tag>
              <div className="max-w-[110px] overflow-hidden">
                <Typography
                  type="p"
                  textColor="black"
                  fontWeight="font-light"
                  fontFamily="font-kanit"
                  customStyles="flex gap-1 truncate overflow-hidden text-ellipsis whitespace-nowrap"
                >
                  <Typography type="span">{user.fullName}</Typography>
                </Typography>
              </div>
            </div>
          </div>
          <RoundedButton
            className="bg-gray-border hover:bg-gray transition"
            icon={<GearIcon color="#ACADAE" />}
          />
        </>
      )}
    </div>
  );
}
